export default "__VITE_ASSET__CL05lQYx__"